import {createSvgIcon} from '../create-svg-icon';

export const KeyboardArrowUpIcon = createSvgIcon(
  <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
, 'KeyboardArrowUpOutlined');
